import { defaultInstance } from 'src/api/instance';
import { getConfigVars } from 'src/helpers';
import { AssetVerificationReviewResponse, RecalculateAssetsResponse } from './ts/interfaces';
import { CompleteReviewPayload, RecalculatePayload } from './utils';

const apiUrl = getConfigVars(window.location.hostname).api_url;

// ITL-2996 — hand-rolled because the SDK can't be regenerated (CLAUDE.md).
// GET path confirmed against ITL-2997 (review_controller.ex); the complete
// endpoint is still PROVISIONAL — it lands in ITL-2997 Phase 4.
const api = {
  getReview: async (entryId: string): Promise<AssetVerificationReviewResponse> => {
    // The axios interceptor unwraps to the HTTP body, and ReviewView wraps the
    // record in { data } — unwrap here so callers always get the flat record.
    const body = (await defaultInstance.get(
      `${apiUrl}/asset_verifications/submission/${entryId}/review`
    )) as unknown as { data: AssetVerificationReviewResponse };
    return body.data;
  },
  completeReview: async (entryId: string, payload: CompleteReviewPayload) =>
    defaultInstance.post(
      `${apiUrl}/asset_verifications/submission/${entryId}/review/complete`,
      payload
    ),
  // Pre-submit preview (contract §6): FVS computes the totals the summary renders,
  // sharing the complete compute path. PROVISIONAL — the FP proxy lands in ITL-3059
  // (FVS endpoint: ITL-3075). Same { data } envelope convention as getReview.
  recalculateReview: async (
    entryId: string,
    payload: RecalculatePayload
  ): Promise<RecalculateAssetsResponse> => {
    const body = (await defaultInstance.post(
      `${apiUrl}/asset_verifications/submission/${entryId}/review/recalculate`,
      payload
    )) as unknown as { data: RecalculateAssetsResponse };
    return body.data;
  }
};

export default api;
